<template>
  <div>
    <!-- 自身模块 -->
    <div class="banner self-banner">
      <!-- <div class="banner-title">通用表格识别演示</div>
      <div class="banner-introduce">功能介绍</div> -->
      <div class="banner-content">
        <div class="inner">
          <div class="ocr">
            <div class="left">
              <ocrLeft
                :ocrUrl="ocrUrl"
                :preview_img="preview_img"
                @getOcrResult="getOcrResult"
                :coordinate="coordinate"
                :imgIndex="imgIndex"
                :canvas_rotate="canvas_rotate"
                :ocr_id="reco_id"
              ></ocrLeft>
            </div>
            <div class="right">
              <el-collapse v-model="activeNames" accordion>
                <el-collapse-item name="1">
                  <template slot="title">
                    <div class="title">
                      <img :src="require('../../assets/img/tb.png')" alt="" />
                      <span>识别结果</span>
                    </div>
                  </template>
                  <!-- <div class="result-pages">
                    <div class="page-cell">
                      <span class="page-item">表格1</span>
                    </div>
                  </div>
                  <div class="result-content">
                    <div class="result-item">
                      <div class="title">
                        
                      </div>
                      <div class="content">

                      </div>
                    </div>
                  </div> -->
                  <div class="result" v-if="resp_data">
                    <div
                      class="table-list"
                      v-for="(v, k) in resp_data.result"
                      :key="k"
                      style="width:100%;"
                    >
                      
                      <!-- <div class="table-title">{{v.description}}</div> -->
                      <table class="ocr-table">
                        <caption>{{v.description}}</caption>
                        <tr>
                          <td v-for="(s, k) in v.column_info" :key="k">
                            {{ s }}
                          </td>
                        </tr>
                        <tr v-for="(item, index) in v.data" :key="index">
                          <td v-for="(td,i) in item" :key="i" @click="resultMouseClick(td)">{{td.words}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <ocrNoResult v-else></ocrNoResult>
                  <!-- <div class="no-result" v-else>
                    <div class="no-cell">
                      <div><img :src="require('../../assets/img/empty.png')" alt=""></div>
                      <div>数据为空</div>
                    </div>
                  </div> -->
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template slot="title">
                    <div class="title">
                      <img :src="require('../../assets/img/tb2.png')" alt="" />
                      <span>Response JSON</span>
                    </div>
                  </template>
                  <ocrResult :resp_data="resp_data"></ocrResult>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ocrLeft from "../../components/ocr-left.vue";
import ocrResult from "../../components/ocr-result.vue";
import ocrNoResult from "../../components/ocr-no-result.vue";

import preview_data from "../../../static/preview_data/financial_report.js";

export default {
  components: {
    ocrLeft,
    ocrResult,
    ocrNoResult,
  },
  data() {
    return {
      firstKey: 0,
      secondKey: 1,
      activeNames: ["1"],
      tables: [],
      resp_data: "",
      coordinate: [],
      preview_img: [],
      imgIndex: 0, // 当前显示的哪个图片
      canvas_rotate: 0
    };
  },
  computed: {
    ocrUrl() {
      return this.$menuData[0].childs.v1_financial_report.ocr_url;
    },
    reco_id(){
      return this.$menuData[0].childs.v1_financial_report.reco_id;
    }
  },
  methods: {
    getOcrResult(result) {
      this.resp_data = result.resp_data;

      if(!result.isMemory){
        this.preview_img.push(result.up_imgBase64);
        this.imgIndex = this.preview_img.length - 1;
      }else{
        this.imgIndex = result.imgIndex;
      }

      this.canvas_rotate = Number(
        result.resp_data.rotation !== undefined ? -result.resp_data.rotation : 0
      );
    },

    resultMouseClick(data) {
      let coord = data.quad.split(",");
      this.coordinate = {
        index: this.imgIndex,
        coordinate: coord,
      };
    },
  },
  mounted() {
    this.resp_data = preview_data;
    this.preview_img = [
      require("../../../static/preview_img/fs.jpg"),
    ];
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/general_docs/financial_report.vue